import Box from '@mui/material/Box'
import {Select, Text} from '../../1elements'

const LocationImportTypeDropdown = ({value, onChange, disabled, validation}) => {
    const options = ['Add one location', 'Add multiple locations'];

    return(
        <Box sx={{ maxWidth: '400px' }}>
            <Text type={'fieldLabel'}>Select an option to add<span className={'requiredAsterisk'} >*</span></Text>
            <Select options={options} helperText={'Select One'} value={value} onChange={onChange}
            disabled={disabled} validation={validation} />
        </Box>
    );
}

export default LocationImportTypeDropdown
